// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: vQ4XUiaXZJugVeQd5GtRbX
// Component: YOXczNdMOAV9
import * as React from "react"
import { Link } from "gatsby"
import * as p from "@plasmicapp/react-web"
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
} from "@plasmicapp/react-web"
import "@plasmicapp/react-web/lib/plasmic.css"
import * as defaultcss from "../plasmic__default_style.module.css" // plasmic-import: global/defaultcss
import * as projectcss from "./plasmic_kube_data_website.module.css" // plasmic-import: vQ4XUiaXZJugVeQd5GtRbX/projectcss
import * as sty from "./PlasmicHomepage.module.css" // plasmic-import: YOXczNdMOAV9/css
import Ellipse61Icon from "./icons/PlasmicIcon__Ellipse61" // plasmic-import: rbq0FoNo3Z/icon
import Ellipse62Icon from "./icons/PlasmicIcon__Ellipse62" // plasmic-import: -JKfDEcJLW/icon
import Ellipse63Icon from "./icons/PlasmicIcon__Ellipse63" // plasmic-import: vElKzlap5y/icon
import Ellipse64Icon from "./icons/PlasmicIcon__Ellipse64" // plasmic-import: 2rqmLnRTQo/icon
import Ellipse66Icon from "./icons/PlasmicIcon__Ellipse66" // plasmic-import: _wYMmSMit9N/icon
import IconsGeneralCart2Icon from "./icons/PlasmicIcon__IconsGeneralCart2" // plasmic-import: n8vtQVWHrQX/icon
import Ellipse4Icon from "./icons/PlasmicIcon__Ellipse4" // plasmic-import: B-om_wvZnPu/icon
import IconnavigationarrowDownward24Px2Icon from "./icons/PlasmicIcon__IconnavigationarrowDownward24Px2" // plasmic-import: MuY74fvGwGo/icon
import CoolDots26Icon from "./icons/PlasmicIcon__CoolDots26" // plasmic-import: YHogDqJWQ1n/icon
import CoolDots54Icon from "./icons/PlasmicIcon__CoolDots54" // plasmic-import: 7wTkF3vj3rK/icon
import CoolDots57Icon from "./icons/PlasmicIcon__CoolDots57" // plasmic-import: SGC4K_7HR/icon
import CoolDots51Icon from "./icons/PlasmicIcon__CoolDots51" // plasmic-import: 9A4sBPI1pu/icon
import CoolDots52Icon from "./icons/PlasmicIcon__CoolDots52" // plasmic-import: dMwBa2JMPD/icon
import Instagram2Icon from "./icons/PlasmicIcon__Instagram2" // plasmic-import: nE14KTqH39j/icon
import Twitter2Icon from "./icons/PlasmicIcon__Twitter2" // plasmic-import: wLjt-QxR8ee/icon
import Ellipse67Icon from "./icons/PlasmicIcon__Ellipse67" // plasmic-import: O81mROWhxCG/icon
import Ellipse68Icon from "./icons/PlasmicIcon__Ellipse68" // plasmic-import: PuExVNABD07/icon
import Ellipse69Icon from "./icons/PlasmicIcon__Ellipse69" // plasmic-import: 11UYshvo1c_/icon
import CoolDots55Icon from "./icons/PlasmicIcon__CoolDots55" // plasmic-import: usds6WKERwn/icon
import GoogleLogo2Icon from "./icons/PlasmicIcon__GoogleLogo2" // plasmic-import: J34HGCppN_F/icon
import G172Icon from "./icons/PlasmicIcon__G172" // plasmic-import: yE5gHG_XL9b/icon
import Path232Icon from "./icons/PlasmicIcon__Path232" // plasmic-import: A4YOAds5ee1/icon
import Ellipse5Icon from "./icons/PlasmicIcon__Ellipse5" // plasmic-import: Oxmx0EnRq4X1/icon
import Frame3Icon from "./icons/PlasmicIcon__Frame3" // plasmic-import: 8dC_rcKPi3y_/icon
import Frame4Icon from "./icons/PlasmicIcon__Frame4" // plasmic-import: gQjN6_sG6QV3/icon
import Slider2Icon from "./icons/PlasmicIcon__Slider2" // plasmic-import: wAoaLTjL25up/icon
import Ellipse70Icon from "./icons/PlasmicIcon__Ellipse70" // plasmic-import: vE1xXZ8TJtIw/icon
import Ellipse71Icon from "./icons/PlasmicIcon__Ellipse71" // plasmic-import: Gpn2k3aiF/icon
import CoolDots58Icon from "./icons/PlasmicIcon__CoolDots58" // plasmic-import: ypCxYShdaRV/icon
import Vector102Icon from "./icons/PlasmicIcon__Vector102" // plasmic-import: SmuhHIeNg00/icon
import CoolDots59Icon from "./icons/PlasmicIcon__CoolDots59" // plasmic-import: d8n5pamzl9P/icon
import AntDesigninstagramOutlined2Icon from "./icons/PlasmicIcon__AntDesigninstagramOutlined2" // plasmic-import: stctmFAMljh/icon
import ellipse65DAsPkAw8Y from "./images/ellipse65.svg" // plasmic-import: DAs-pkAW8Y/picture
import g8432FNaFqNkZtg from "./images/g8432.svg" // plasmic-import: fNAFqNkZTG/picture
import airbnbLogo2PYNt6AwKKl from "./images/airbnbLogo2.svg" // plasmic-import: pYNt6awK-Kl/picture
import microsoftLogo204Ve6AGRvc from "./images/microsoftLogo2.svg" // plasmic-import: 04ve6A_gRvc/picture
import vector52HHaHkBbysAy from "./images/vector52.svg" // plasmic-import: hHaHkBBYSAy/picture
import vector53JyVoq8Uxi98 from "./images/vector53.svg" // plasmic-import: jyVOQ8Uxi98/picture
import vector54UtMQsyRW from "./images/vector54.svg" // plasmic-import: Ut-M_qsyR-W/picture
import vector55B01Maj5Jg7V from "./images/vector55.svg" // plasmic-import: B01maj5Jg7v/picture
import vector56FrNjgj4SZk from "./images/vector56.svg" // plasmic-import: FrNjgj4_SZk/picture
import vector57T2TiWdgWqlR from "./images/vector57.svg" // plasmic-import: t2TIWdgWqlR/picture
import vector58LCCkhaU3Bf from "./images/vector58.svg" // plasmic-import: lCCkha_u3Bf/picture
import vector59E4XWdtSwFkh from "./images/vector59.svg" // plasmic-import: E4xWdtSWFkh/picture
import vector60IjwqYe1VbIf from "./images/vector60.svg" // plasmic-import: IJWQYe1VbIF/picture
import vector61NNwpzmqHEw from "./images/vector61.svg" // plasmic-import: NNwpzmqH-EW/picture
import vector62SQqVop35J7 from "./images/vector62.svg" // plasmic-import: sQqVop35J7_/picture
import vector63NdApgq85JH from "./images/vector63.svg" // plasmic-import: NDApgq85j-h/picture
import vector64BMw5TQskV9 from "./images/vector64.svg" // plasmic-import: bMW5tQSK-v9/picture
import vector657DS5JAsbkYa from "./images/vector65.svg" // plasmic-import: 7dS5jAsbkYa/picture
import vector66VQypWzDKzuB from "./images/vector66.svg" // plasmic-import: VQypWzDKzuB/picture
import vector67WxolrOApMnZ from "./images/vector67.svg" // plasmic-import: WxolrOApMnZ/picture
import vector68Lq1CnHfGbJz from "./images/vector68.svg" // plasmic-import: lq1cnHfGbJz/picture
import vector691GwmnofxQqC from "./images/vector69.svg" // plasmic-import: 1GwmnofxQqC/picture
import vector70J0JOTveVgWq from "./images/vector70.svg" // plasmic-import: j0jOTveVgWQ/picture
import vector710QfsbtGjbSy from "./images/vector71.svg" // plasmic-import: 0QFSBTGjbSy/picture
import vector72TF8X4UsNpna from "./images/vector72.svg" // plasmic-import: tF8x4UsNPNA/picture
import vector73Uv1Juc4NT3 from "./images/vector73.svg" // plasmic-import: Uv1Juc4n_t3/picture
import vector747MhFkoGadh from "./images/vector74.svg" // plasmic-import: 7-MhFKOGadh/picture
import vector75P7RgoNVlNdj from "./images/vector75.svg" // plasmic-import: P7rgoNVlNDJ/picture
import vector76QtHnetRwcgU from "./images/vector76.svg" // plasmic-import: qtHnetRwcgU/picture
import vector77HhejFtAeVlG from "./images/vector77.svg" // plasmic-import: hhejFtAeVlG/picture
import vector78YKrxSpuD0Up from "./images/vector78.svg" // plasmic-import: yKrxSpuD0Up/picture
import vector79CQov5UIFqN from "./images/vector79.svg" // plasmic-import: cQov5U_IFqN/picture
import vector80RRnROHdFdY from "./images/vector80.svg" // plasmic-import: rRnR_oHdFdY/picture
import vector81EkGGmdFnF06 from "./images/vector81.svg" // plasmic-import: ekGGmdFnF06/picture
import vector82FMyWlf6UlCz from "./images/vector82.svg" // plasmic-import: fMyWLF6ulCz/picture
import vector83IPnWguGmd9 from "./images/vector83.svg" // plasmic-import: I-pnWGUGmd9/picture
import vector84HgSspzqtvi from "./images/vector84.svg" // plasmic-import: hgSSPZQTVI-/picture
import vector85AQfMgYrWj8L from "./images/vector85.svg" // plasmic-import: AQfMGYrWj8L/picture
import vector86MPfCHFkUca from "./images/vector86.svg" // plasmic-import: mPfC-HFkUca/picture
import vector873AAlReubmW2 from "./images/vector87.svg" // plasmic-import: 3aAlReubmW2/picture
import vector88DXpZUdyQcvt from "./images/vector88.svg" // plasmic-import: dXpZUdyQCVT/picture
import vector89Uos0Yw3Yzlz from "./images/vector89.svg" // plasmic-import: UOS0yw3YZLZ/picture
import vector90UolE7Jv6EuI from "./images/vector90.svg" // plasmic-import: uolE7jv6euI/picture
import vector91Dzau8DhUni from "./images/vector91.svg" // plasmic-import: DZAU8DhUNI_/picture
import vector92MeSo2Cs7AnH from "./images/vector92.svg" // plasmic-import: MESo2cs7anH/picture
import vector93FMdReWqDl6 from "./images/vector93.svg" // plasmic-import: f_MDReWQDl6/picture
import vector948Vfd75JZ2O from "./images/vector94.svg" // plasmic-import: 8Vfd75j_Z2O/picture
import vector95TIG1TvsVcwc from "./images/vector95.svg" // plasmic-import: t-iG1tvsVcwc/picture
import vector960Fr8Pp4Oyvv from "./images/vector96.svg" // plasmic-import: 0FR8Pp4-oyvv/picture
import vector97XlFLqJ3T39N from "./images/vector97.svg" // plasmic-import: Xl_fLqJ3T39N/picture
import vector984GkmaWiaPo8N from "./images/vector98.svg" // plasmic-import: 4GKMAWiaPO8N/picture
import vector99Fh8QDkG9P4Tu from "./images/vector99.svg" // plasmic-import: FH8QDkG9p4TU/picture
import vector100G0OOx23MreVu from "./images/vector100.svg" // plasmic-import: g0oOx23MREVu/picture
import vector101WfXIguOCw9 from "./images/vector101.svg" // plasmic-import: wf_x-IguOCw9/picture
import group60ASi3Drsfy from "./images/group6.svg" // plasmic-import: 0aSI3DRSFY/picture
import group7Pwz9SQtWhF from "./images/group7.svg" // plasmic-import: pwz9-sQtWhF/picture
import group8ZmId5XkWy3P from "./images/group8.svg" // plasmic-import: zmId5xkWy3P/picture
import featureIcons2A7CcvYjBqg from "./images/featureIcons2.svg" // plasmic-import: A7_ccvYjBQG/picture
import group9H8Y41LzW38C from "./images/group9.svg" // plasmic-import: h8y41LzW38c/picture
import group10PKp2ECbRBy from "./images/group10.svg" // plasmic-import: p_KP2ECbRBy/picture
import antDesignfacebookFilled2PQaf164UQa from "./images/antDesignfacebookFilled2.svg" // plasmic-import: PQaf164-UQa/picture
import antDesigntwitterOutlined2Xdr24EpeWh from "./images/antDesigntwitterOutlined2.svg" // plasmic-import: -XDR24EpeWh/picture

export const PlasmicHomepage__VariantProps = new Array()

export const PlasmicHomepage__ArgProps = new Array()

function PlasmicHomepage__RenderFunc(props) {
  const { variants, args, overrides, forNode, dataFetches } = props
  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={defaultcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            defaultcss.all,
            projectcss.root_reset,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"mntnBlue2"}
            data-plasmic-override={overrides.mntnBlue2}
            className={classNames(defaultcss.all, sty.mntnBlue2)}
          >
            <div
              data-plasmic-name={"homeHeroSection2"}
              data-plasmic-override={overrides.homeHeroSection2}
              className={classNames(defaultcss.all, sty.homeHeroSection2)}
            >
              {false ? (
                <div
                  data-plasmic-name={"home2"}
                  data-plasmic-override={overrides.home2}
                  className={classNames(defaultcss.all, sty.home2)}
                />
              ) : null}

              <Ellipse61Icon
                className={classNames(defaultcss.all, sty.svg__wwWze)}
                role={"img"}
              />

              <Ellipse62Icon
                className={classNames(defaultcss.all, sty.svg__l1WdU)}
                role={"img"}
              />

              <Ellipse63Icon
                className={classNames(defaultcss.all, sty.svg__py4Rt)}
                role={"img"}
              />

              <Ellipse64Icon
                className={classNames(defaultcss.all, sty.svg__gdeYl)}
                role={"img"}
              />

              <img
                data-plasmic-name={"line"}
                data-plasmic-override={overrides.line}
                alt={""}
                className={classNames(defaultcss.img, sty.line)}
                role={"img"}
                src={ellipse65DAsPkAw8Y}
              />

              <Ellipse66Icon
                data-plasmic-name={"circle"}
                data-plasmic-override={overrides.circle}
                className={classNames(defaultcss.all, sty.circle)}
                role={"img"}
              />

              <div className={classNames(defaultcss.all, sty.box__pg6D6)}>
                <div
                  className={classNames(
                    defaultcss.all,
                    defaultcss.__wab_text,
                    sty.box__ipSsz
                  )}
                >
                  {"Scroll Down"}
                </div>
              </div>

              <div className={classNames(defaultcss.all, sty.box__tySat)}>
                {false ? (
                  <div
                    data-plasmic-name={"account2"}
                    data-plasmic-override={overrides.account2}
                    className={classNames(defaultcss.all, sty.account2)}
                  >
                    <div
                      className={classNames(
                        defaultcss.all,
                        defaultcss.__wab_text,
                        sty.box__gffxl
                      )}
                    >
                      {"Account"}
                    </div>

                    <IconsGeneralCart2Icon
                      className={classNames(defaultcss.all, sty.svg___72WPr)}
                      role={"img"}
                    />
                  </div>
                ) : null}

                <div
                  data-plasmic-name={"middleLinks2"}
                  data-plasmic-override={overrides.middleLinks2}
                  className={classNames(defaultcss.all, sty.middleLinks2)}
                >
                  <p.PlasmicLink
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.link__bk1Vt
                    )}
                    component={Link}
                    href={"/contact"}
                    platform={"gatsby"}
                  >
                    {"Contact"}
                  </p.PlasmicLink>

                  <p.PlasmicLink
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.link__hZySe
                    )}
                    component={Link}
                    href={"/careers"}
                    platform={"gatsby"}
                  >
                    {"Careers"}
                  </p.PlasmicLink>

                  <p.PlasmicLink
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.link__e19Fj
                    )}
                    component={Link}
                    href={"#"}
                    platform={"gatsby"}
                  >
                    {"IOT Consulting"}
                  </p.PlasmicLink>

                  <p.PlasmicLink
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.link__zcom2
                    )}
                    component={Link}
                    href={"#solutions"}
                    platform={"gatsby"}
                  >
                    {"Solutions"}
                  </p.PlasmicLink>

                  <p.PlasmicLink
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.link__r99FV
                    )}
                    component={Link}
                    href={"#about"}
                    platform={"gatsby"}
                  >
                    {"About"}
                  </p.PlasmicLink>

                  <Ellipse4Icon
                    className={classNames(defaultcss.all, sty.svg__sBT)}
                    role={"img"}
                  />
                </div>

                <p.Stack
                  as={p.PlasmicLink}
                  hasGap={true}
                  className={classNames(defaultcss.all, sty.link__omnoD)}
                  component={Link}
                  href={"/login"}
                  platform={"gatsby"}
                >
                  <div
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.box__itRvs
                    )}
                  >
                    {"Login"}
                  </div>
                </p.Stack>

                <p.PlasmicLink
                  className={classNames(defaultcss.all, sty.link__hzhBe)}
                  component={Link}
                  href={"/"}
                  platform={"gatsby"}
                >
                  <div
                    data-plasmic-name={"rectangle594"}
                    data-plasmic-override={overrides.rectangle594}
                    className={classNames(defaultcss.all, sty.rectangle594)}
                  />
                </p.PlasmicLink>
              </div>

              <p.Stack
                as={p.PlasmicLink}
                hasGap={true}
                className={classNames(defaultcss.all, sty.link___6Jkhv)}
                component={Link}
                href={"#solutions"}
                platform={"gatsby"}
              >
                <div
                  className={classNames(
                    defaultcss.all,
                    defaultcss.__wab_text,
                    sty.box__iaIj
                  )}
                >
                  {"Learn More"}
                </div>
              </p.Stack>

              <p.Stack
                as={p.PlasmicLink}
                hasGap={true}
                className={classNames(defaultcss.all, sty.link__juGJy)}
                component={Link}
                href={"/services"}
                platform={"gatsby"}
              >
                <div
                  className={classNames(
                    defaultcss.all,
                    defaultcss.__wab_text,
                    sty.box__ljsY4
                  )}
                >
                  {"Get Started"}
                </div>
              </p.Stack>

              <p.Stack
                as={"div"}
                data-plasmic-name={"content2"}
                data-plasmic-override={overrides.content2}
                hasGap={true}
                className={classNames(defaultcss.all, sty.content2)}
              >
                <div className={classNames(defaultcss.all, sty.box__teKxk)}>
                  <span className={classNames(defaultcss.all, sty.span__veJce)}>
                    <div
                      className={classNames(
                        defaultcss.all,
                        defaultcss.__wab_text,
                        sty.box__skhrE
                      )}
                    >
                      {"IOT Services - "}
                    </div>
                  </span>

                  <span className={classNames(defaultcss.all, sty.span__tawK2)}>
                    <div
                      className={classNames(
                        defaultcss.all,
                        defaultcss.__wab_text,
                        sty.box__ebaU
                      )}
                    >
                      {"Leading Data solutions"}
                    </div>
                  </span>
                </div>

                <div
                  className={classNames(
                    defaultcss.all,
                    defaultcss.__wab_text,
                    sty.box__vv6BV
                  )}
                >
                  {
                    "Lorem ipsum is common placeholder text used to demonstrate the graphic elements of a document or visual presentation."
                  }
                </div>

                <div className={classNames(defaultcss.all, sty.box__riVOj)}>
                  {false ? (
                    <IconnavigationarrowDownward24Px2Icon
                      className={classNames(defaultcss.all, sty.svg__d7Tg2)}
                      role={"img"}
                    />
                  ) : null}
                </div>
              </p.Stack>

              <CoolDots26Icon
                className={classNames(defaultcss.all, sty.svg__oGj2W)}
                role={"img"}
              />

              <div
                data-plasmic-name={"coolDots1"}
                data-plasmic-override={overrides.coolDots1}
                className={classNames(defaultcss.all, sty.coolDots1)}
              >
                <CoolDots54Icon
                  className={classNames(defaultcss.all, sty.svg__eM3JX)}
                  role={"img"}
                />

                <CoolDots54Icon
                  className={classNames(defaultcss.all, sty.svg__yg0QM)}
                  role={"img"}
                />

                <CoolDots54Icon
                  className={classNames(defaultcss.all, sty.svg__rQg5P)}
                  role={"img"}
                />

                <CoolDots54Icon
                  className={classNames(defaultcss.all, sty.svg__lhTWm)}
                  role={"img"}
                />

                <CoolDots57Icon
                  className={classNames(defaultcss.all, sty.svg__fEqZv)}
                  role={"img"}
                />
              </div>

              <div className={classNames(defaultcss.all, sty.box__dePbg)}>
                <CoolDots51Icon
                  className={classNames(defaultcss.all, sty.svg__d5YlB)}
                  role={"img"}
                />

                <CoolDots52Icon
                  className={classNames(defaultcss.all, sty.svg__prAul)}
                  role={"img"}
                />
              </div>

              <div
                data-plasmic-name={"cloudComputingImg2"}
                data-plasmic-override={overrides.cloudComputingImg2}
                className={classNames(defaultcss.all, sty.cloudComputingImg2)}
              >
                <div
                  data-plasmic-name={"layer12"}
                  data-plasmic-override={overrides.layer12}
                  className={classNames(defaultcss.all, sty.layer12)}
                >
                  <img
                    alt={""}
                    className={classNames(defaultcss.img, sty.img__baVaJ)}
                    role={"img"}
                    src={g8432FNaFqNkZtg}
                  />
                </div>
              </div>

              <div className={classNames(defaultcss.all, sty.box___2U79E)}>
                <div
                  className={classNames(
                    defaultcss.all,
                    defaultcss.__wab_text,
                    sty.box___6Qwpq
                  )}
                >
                  {"Follow us"}
                </div>

                <p.PlasmicLink
                  className={classNames(defaultcss.all, sty.link__w8Y7W)}
                  component={Link}
                  href={"#"}
                  platform={"gatsby"}
                >
                  <Instagram2Icon
                    className={classNames(defaultcss.all, sty.svg__uqm7Y)}
                    role={"img"}
                  />
                </p.PlasmicLink>

                <p.PlasmicLink
                  className={classNames(defaultcss.all, sty.link__y9Jm)}
                  component={Link}
                  href={"#"}
                  platform={"gatsby"}
                >
                  <Twitter2Icon
                    className={classNames(defaultcss.all, sty.svg__fU5J)}
                    role={"img"}
                  />
                </p.PlasmicLink>
              </div>
            </div>

            <div
              data-plasmic-name={"aboutSection2"}
              data-plasmic-override={overrides.aboutSection2}
              className={classNames(defaultcss.all, sty.aboutSection2)}
              id={"about"}
            >
              <div
                className={classNames(defaultcss.all, sty.box__kEmoD)}
                id={""}
              />

              <Ellipse67Icon
                className={classNames(defaultcss.all, sty.svg__vuL8Q)}
                role={"img"}
              />

              <Ellipse68Icon
                className={classNames(defaultcss.all, sty.svg__xS16)}
                role={"img"}
              />

              <Ellipse69Icon
                className={classNames(defaultcss.all, sty.svg__ti4Uc)}
                role={"img"}
              />

              <div className={classNames(defaultcss.all, sty.box__rk63P)}>
                <CoolDots55Icon
                  className={classNames(defaultcss.all, sty.svg__dh5LP)}
                  role={"img"}
                />

                <CoolDots54Icon
                  className={classNames(defaultcss.all, sty.svg__lzXdd)}
                  role={"img"}
                />
              </div>

              <div className={classNames(defaultcss.all, sty.box__tsag0)}>
                <div className={classNames(defaultcss.all, sty.box__jmLMl)}>
                  <div
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.box__o4Knd
                    )}
                  >
                    {"Why Businesses choose our\nIOT Services"}
                  </div>

                  <div
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.box__vegQg
                    )}
                  >
                    {
                      "KubeData is blah blah lorem ipsum dola doriem. Lorem ipsum is common placeholder text used to demonstrate the graphic elements of a document or visual presentation.\n\nOur dedicated patient engagement app and web portal allow you to access information instantaneously (no tedeous form, long calls, or administrative hassle) and securely"
                    }
                  </div>

                  <div className={classNames(defaultcss.all, sty.box__lIn)} />
                </div>

                <p.Stack
                  as={p.PlasmicLink}
                  hasGap={true}
                  className={classNames(defaultcss.all, sty.link__o6EO3)}
                  component={Link}
                  href={"/iot-services"}
                  platform={"gatsby"}
                >
                  <div
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.box__ejIIf
                    )}
                  >
                    {"Learn More"}
                  </div>
                </p.Stack>
              </div>

              <div
                data-plasmic-name={"trafalgarIllustrationSec032"}
                data-plasmic-override={overrides.trafalgarIllustrationSec032}
                className={classNames(
                  defaultcss.all,
                  sty.trafalgarIllustrationSec032
                )}
              />

              <div className={classNames(defaultcss.all, sty.box__b7Np1)}>
                <div
                  data-plasmic-name={"cardItem2"}
                  data-plasmic-override={overrides.cardItem2}
                  className={classNames(defaultcss.all, sty.cardItem2)}
                >
                  <p.Stack
                    as={"div"}
                    data-plasmic-name={"flexRow2"}
                    data-plasmic-override={overrides.flexRow2}
                    hasGap={true}
                    className={classNames(defaultcss.all, sty.flexRow2)}
                  >
                    <h3
                      className={classNames(
                        defaultcss.h3,
                        defaultcss.__wab_text,
                        sty.h3__mzRll
                      )}
                    >
                      {"Subscribe to our Newsletter \nfor the Latest  "}
                    </h3>

                    <div className={classNames(defaultcss.all, sty.box__i8Ir)}>
                      <div
                        data-plasmic-name={"inputGroup2"}
                        data-plasmic-override={overrides.inputGroup2}
                        className={classNames(defaultcss.all, sty.inputGroup2)}
                      >
                        <form
                          data-plasmic-name={"formControlInputStyle12"}
                          data-plasmic-override={
                            overrides.formControlInputStyle12
                          }
                          className={classNames(
                            defaultcss.all,
                            sty.formControlInputStyle12
                          )}
                        >
                          <div
                            className={classNames(
                              defaultcss.all,
                              defaultcss.__wab_text,
                              sty.box__yajDy
                            )}
                          >
                            {"Your Email"}
                          </div>
                        </form>

                        <div
                          data-plasmic-name={"inputGroupAppend2"}
                          data-plasmic-override={overrides.inputGroupAppend2}
                          className={classNames(
                            defaultcss.all,
                            sty.inputGroupAppend2
                          )}
                        />

                        <p.Stack
                          as={p.PlasmicLink}
                          hasGap={true}
                          className={classNames(
                            defaultcss.all,
                            sty.link__i4Xkr
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          <div
                            className={classNames(
                              defaultcss.all,
                              defaultcss.__wab_text,
                              sty.box___6CTxT
                            )}
                          >
                            {"Subscribe"}
                          </div>
                        </p.Stack>
                      </div>
                    </div>
                  </p.Stack>
                </div>
              </div>

              <p.Stack
                as={"div"}
                data-plasmic-name={"logosSection2"}
                data-plasmic-override={overrides.logosSection2}
                hasGap={true}
                className={classNames(defaultcss.all, sty.logosSection2)}
              >
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"logos2"}
                  data-plasmic-override={overrides.logos2}
                  hasGap={true}
                  className={classNames(defaultcss.all, sty.logos2)}
                >
                  <img
                    alt={""}
                    className={classNames(defaultcss.img, sty.img__uhvdG)}
                    role={"img"}
                    src={airbnbLogo2PYNt6AwKKl}
                  />

                  <GoogleLogo2Icon
                    className={classNames(defaultcss.all, sty.svg__qP52)}
                    role={"img"}
                  />

                  <img
                    alt={""}
                    className={classNames(defaultcss.img, sty.img__jnOoR)}
                    role={"img"}
                    src={microsoftLogo204Ve6AGRvc}
                  />

                  <div
                    data-plasmic-name={"fedExLogo2"}
                    data-plasmic-override={overrides.fedExLogo2}
                    className={classNames(defaultcss.all, sty.fedExLogo2)}
                  >
                    <div
                      data-plasmic-name={"g152"}
                      data-plasmic-override={overrides.g152}
                      className={classNames(defaultcss.all, sty.g152)}
                    >
                      <G172Icon
                        className={classNames(defaultcss.all, sty.svg__zvmJt)}
                        role={"img"}
                      />

                      <Path232Icon
                        className={classNames(defaultcss.all, sty.svg___0Kr3)}
                        role={"img"}
                      />
                    </div>
                  </div>
                </p.Stack>
              </p.Stack>
            </div>

            <div
              data-plasmic-name={"testimonialsSection2"}
              data-plasmic-override={overrides.testimonialsSection2}
              className={classNames(defaultcss.all, sty.testimonialsSection2)}
            >
              <div className={classNames(defaultcss.all, sty.box___8IRzV)} />

              <div className={classNames(defaultcss.all, sty.box__uB9Pf)}>
                <div
                  data-plasmic-name={"simpleTransparent2"}
                  data-plasmic-override={overrides.simpleTransparent2}
                  className={classNames(
                    defaultcss.all,
                    defaultcss.__wab_text,
                    sty.simpleTransparent2
                  )}
                >
                  {"Testimonials"}
                </div>
              </div>

              <div
                data-plasmic-name={"testimonials2"}
                data-plasmic-override={overrides.testimonials2}
                className={classNames(defaultcss.all, sty.testimonials2)}
              >
                <div className={classNames(defaultcss.all, sty.box__o1PwG)}>
                  <div className={classNames(defaultcss.all, sty.box__ctJtS)}>
                    <div
                      className={classNames(defaultcss.all, sty.box___6Nce4)}
                    >
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__i9Nos)}
                        role={"img"}
                        src={vector52HHaHkBbysAy}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__uRmlu)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__ncE97)}
                        role={"img"}
                        src={vector53JyVoq8Uxi98}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__uvnJi)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__h9Gjd)}
                        role={"img"}
                        src={vector54UtMQsyRW}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__z3NZz)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__yrJna)}
                        role={"img"}
                        src={vector55B01Maj5Jg7V}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__vEuQt)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__cFdXc)}
                        role={"img"}
                        src={vector56FrNjgj4SZk}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__zf5Fb)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__pvHaF)}
                        role={"img"}
                        src={vector57T2TiWdgWqlR}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__dhfpA)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__oOO2)}
                        role={"img"}
                        src={vector58LCCkhaU3Bf}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__zrHn9)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__m3F0Z)}
                        role={"img"}
                        src={vector59E4XWdtSwFkh}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__xC9F)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__xVsYv)}
                        role={"img"}
                        src={vector60IjwqYe1VbIf}
                      />
                    </div>

                    <div
                      className={classNames(defaultcss.all, sty.box___2WfNi)}
                    >
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__xzumz)}
                        role={"img"}
                        src={vector61NNwpzmqHEw}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__n33T5)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__evHmU)}
                        role={"img"}
                        src={vector62SQqVop35J7}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__nStQ8)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__kfx2M)}
                        role={"img"}
                        src={vector63NdApgq85JH}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box___8QzU)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__rGtm8)}
                        role={"img"}
                        src={vector64BMw5TQskV9}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__fpX0E)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__f36Vc)}
                        role={"img"}
                        src={vector657DS5JAsbkYa}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__eaYqU)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__ibzo9)}
                        role={"img"}
                        src={vector66VQypWzDKzuB}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__yZzdx)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__z5DXx)}
                        role={"img"}
                        src={vector67WxolrOApMnZ}
                      />
                    </div>

                    <div
                      className={classNames(defaultcss.all, sty.box___0Rdae)}
                    >
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img___41OVn)}
                        role={"img"}
                        src={vector68Lq1CnHfGbJz}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__vhAk7)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__jWNuq)}
                        role={"img"}
                        src={vector691GwmnofxQqC}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__smbxN)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__vcyH5)}
                        role={"img"}
                        src={vector70J0JOTveVgWq}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__zvIr)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__amq6U)}
                        role={"img"}
                        src={vector710QfsbtGjbSy}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__nkhf)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__lKkbK)}
                        role={"img"}
                        src={vector72TF8X4UsNpna}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__gXmjW)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__r84K5)}
                        role={"img"}
                        src={vector73Uv1Juc4NT3}
                      />
                    </div>

                    <div
                      className={classNames(defaultcss.all, sty.box___7I06M)}
                    >
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__w1VbM)}
                        role={"img"}
                        src={vector747MhFkoGadh}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__lMhZb)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__hpMfa)}
                        role={"img"}
                        src={vector75P7RgoNVlNdj}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__smxlh)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__wcivm)}
                        role={"img"}
                        src={vector76QtHnetRwcgU}
                      />
                    </div>
                  </div>

                  <div className={classNames(defaultcss.all, sty.box__c8W4J)} />

                  <div className={classNames(defaultcss.all, sty.box__tP53)}>
                    <div className={classNames(defaultcss.all, sty.box__cLqLv)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__qhUjq)}
                        role={"img"}
                        src={vector77HhejFtAeVlG}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__xnsPb)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__wHqHm)}
                        role={"img"}
                        src={vector78YKrxSpuD0Up}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__iJbMa)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__gtcDs)}
                        role={"img"}
                        src={vector79CQov5UIFqN}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__u8TPr)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__bdlsV)}
                        role={"img"}
                        src={vector80RRnROHdFdY}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__fkFh)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__p08Rd)}
                        role={"img"}
                        src={vector81EkGGmdFnF06}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__aVgqJ)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__bccGh)}
                        role={"img"}
                        src={vector82FMyWlf6UlCz}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__phgpu)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__tWeYq)}
                        role={"img"}
                        src={vector83IPnWguGmd9}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__gqjHm)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__t0BGi)}
                        role={"img"}
                        src={vector84HgSspzqtvi}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__xANaL)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__a2PAc)}
                        role={"img"}
                        src={vector85AQfMgYrWj8L}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__yxXOz)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img___8AEn)}
                        role={"img"}
                        src={vector86MPfCHFkUca}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__j5W13)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__nytIf)}
                        role={"img"}
                        src={vector873AAlReubmW2}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__lWUyo)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__l5Llg)}
                        role={"img"}
                        src={vector88DXpZUdyQcvt}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__yUo7M)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__onKjT)}
                        role={"img"}
                        src={vector89Uos0Yw3Yzlz}
                      />
                    </div>

                    <div
                      className={classNames(defaultcss.all, sty.box___6Ai8F)}
                    >
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__uBxdW)}
                        role={"img"}
                        src={vector90UolE7Jv6EuI}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__ug51W)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__ubQjd)}
                        role={"img"}
                        src={vector91Dzau8DhUni}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__hpfBz)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__dhi2S)}
                        role={"img"}
                        src={vector92MeSo2Cs7AnH}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__vhUte)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__dYdIh)}
                        role={"img"}
                        src={vector93FMdReWqDl6}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__rd7Ca)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__ledur)}
                        role={"img"}
                        src={vector948Vfd75JZ2O}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__pyTlk)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img___036Ly)}
                        role={"img"}
                        src={vector95TIG1TvsVcwc}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__xFiib)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__rCyS9)}
                        role={"img"}
                        src={vector960Fr8Pp4Oyvv}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__vOxQq)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__x1DNl)}
                        role={"img"}
                        src={vector97XlFLqJ3T39N}
                      />
                    </div>

                    <div
                      className={classNames(defaultcss.all, sty.box___2Z6UD)}
                    >
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img___2B03N)}
                        role={"img"}
                        src={vector984GkmaWiaPo8N}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__y8Yg)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__omkEq)}
                        role={"img"}
                        src={vector99Fh8QDkG9P4Tu}
                      />
                    </div>

                    <div
                      className={classNames(defaultcss.all, sty.box___8WNay)}
                    >
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img___8IxzQ)}
                        role={"img"}
                        src={vector100G0OOx23MreVu}
                      />
                    </div>

                    <div className={classNames(defaultcss.all, sty.box__kKvyi)}>
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__lWPys)}
                        role={"img"}
                        src={vector101WfXIguOCw9}
                      />
                    </div>
                  </div>

                  <div
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.box___5Bcv5
                    )}
                  >
                    {
                      "“Our dedicated patient engagement app and \nweb portal allow you to access information instantaneously (no tedeous form, long calls, \nor administrative hassle) and securely”"
                    }
                  </div>

                  <div
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.box__qcjO9
                    )}
                  >
                    {"What our customer are saying"}
                  </div>

                  <div
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.box__smdDx
                    )}
                  >
                    {"Edward Newgate"}
                  </div>

                  <div
                    className={classNames(
                      defaultcss.all,
                      defaultcss.__wab_text,
                      sty.box___1UUjU
                    )}
                  >
                    {"Founder Circle"}
                  </div>

                  <div
                    data-plasmic-name={"rectangle18"}
                    data-plasmic-override={overrides.rectangle18}
                    className={classNames(defaultcss.all, sty.rectangle18)}
                  />

                  <div className={classNames(defaultcss.all, sty.box__dZ8Ze)}>
                    <Ellipse5Icon
                      className={classNames(defaultcss.all, sty.svg___1ZwP)}
                      role={"img"}
                    />

                    <div
                      data-plasmic-name={"maskGroup2"}
                      data-plasmic-override={overrides.maskGroup2}
                      className={classNames(defaultcss.all, sty.maskGroup2)}
                    >
                      <div
                        data-plasmic-name={"image2"}
                        data-plasmic-override={overrides.image2}
                        className={classNames(defaultcss.all, sty.image2)}
                      />
                    </div>
                  </div>
                </div>

                <div
                  data-plasmic-name={"arrowNav2"}
                  data-plasmic-override={overrides.arrowNav2}
                  className={classNames(defaultcss.all, sty.arrowNav2)}
                >
                  <Frame3Icon
                    className={classNames(defaultcss.all, sty.svg___1PtjR)}
                    role={"img"}
                  />

                  <Frame4Icon
                    className={classNames(defaultcss.all, sty.svg__b3JM)}
                    role={"img"}
                  />

                  <Slider2Icon
                    className={classNames(defaultcss.all, sty.svg__aOgN3)}
                    role={"img"}
                  />
                </div>
              </div>

              <Ellipse70Icon
                className={classNames(defaultcss.all, sty.svg___8Kq5Y)}
                role={"img"}
              />

              <Ellipse71Icon
                className={classNames(defaultcss.all, sty.svg__rc2X)}
                role={"img"}
              />
            </div>

            <div
              data-plasmic-name={"featuresSection2"}
              data-plasmic-override={overrides.featuresSection2}
              className={classNames(defaultcss.all, sty.featuresSection2)}
              id={"solutions"}
            >
              <div
                data-plasmic-name={"features2"}
                data-plasmic-override={overrides.features2}
                className={classNames(defaultcss.all, sty.features2)}
              />

              <p.Stack
                as={"div"}
                data-plasmic-name={"featureMultiple6"}
                data-plasmic-override={overrides.featureMultiple6}
                hasGap={true}
                className={classNames(defaultcss.all, sty.featureMultiple6)}
              >
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"autoAddedFrame2"}
                  data-plasmic-override={overrides.autoAddedFrame2}
                  hasGap={true}
                  className={classNames(defaultcss.all, sty.autoAddedFrame2)}
                >
                  <p.Stack
                    as={"div"}
                    data-plasmic-name={"titleDescription6ColCenterAlign2"}
                    data-plasmic-override={
                      overrides.titleDescription6ColCenterAlign2
                    }
                    hasGap={true}
                    className={classNames(
                      defaultcss.all,
                      sty.titleDescription6ColCenterAlign2
                    )}
                  >
                    <p.Stack
                      as={"div"}
                      data-plasmic-name={"title6ColCenterAlign2"}
                      data-plasmic-override={overrides.title6ColCenterAlign2}
                      hasGap={true}
                      className={classNames(
                        defaultcss.all,
                        sty.title6ColCenterAlign2
                      )}
                    >
                      <div
                        data-plasmic-name={"sectionTitle2"}
                        data-plasmic-override={overrides.sectionTitle2}
                        className={classNames(
                          defaultcss.all,
                          defaultcss.__wab_text,
                          sty.sectionTitle2
                        )}
                      >
                        {"Tailor-made features"}
                      </div>
                    </p.Stack>

                    <div
                      className={classNames(
                        defaultcss.all,
                        defaultcss.__wab_text,
                        sty.box__bxZhj
                      )}
                    >
                      {
                        "Lorem ipsum is common placeholder text used to demonstrate the graphic elements of a document or visual presentation."
                      }
                    </div>
                  </p.Stack>
                </p.Stack>

                <p.Stack
                  as={"div"}
                  data-plasmic-name={"featuresList2"}
                  data-plasmic-override={overrides.featuresList2}
                  hasGap={true}
                  className={classNames(defaultcss.all, sty.featuresList2)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(defaultcss.all, sty.box__tSfO)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__zkvD3)}
                    >
                      <div
                        data-plasmic-name={"featureIcons5"}
                        data-plasmic-override={overrides.featureIcons5}
                        className={classNames(
                          defaultcss.all,
                          sty.featureIcons5
                        )}
                      >
                        <img
                          alt={""}
                          className={classNames(defaultcss.img, sty.img__cWnOr)}
                          role={"img"}
                          src={group60ASi3Drsfy}
                        />
                      </div>

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box__i8YFr)}
                      >
                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__gcIr
                          )}
                        >
                          {"Multiple layouts"}
                        </div>

                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__nUPwR
                          )}
                        >
                          {
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum."
                          }
                        </div>
                      </p.Stack>
                    </p.Stack>

                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__sJcek)}
                    >
                      <div
                        data-plasmic-name={"featureIcons6"}
                        data-plasmic-override={overrides.featureIcons6}
                        className={classNames(
                          defaultcss.all,
                          sty.featureIcons6
                        )}
                      >
                        <img
                          alt={""}
                          className={classNames(defaultcss.img, sty.img__rv0Yl)}
                          role={"img"}
                          src={group7Pwz9SQtWhF}
                        />
                      </div>

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box__gk0GV)}
                      >
                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box___98U7L
                          )}
                        >
                          {"Better components"}
                        </div>

                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__efm2G
                          )}
                        >
                          {
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum."
                          }
                        </div>
                      </p.Stack>
                    </p.Stack>

                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__gSoP)}
                    >
                      <div
                        data-plasmic-name={"featureIcons9"}
                        data-plasmic-override={overrides.featureIcons9}
                        className={classNames(
                          defaultcss.all,
                          sty.featureIcons9
                        )}
                      >
                        <img
                          alt={""}
                          className={classNames(
                            defaultcss.img,
                            sty.img___7Atkt
                          )}
                          role={"img"}
                          src={group8ZmId5XkWy3P}
                        />
                      </div>

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box__bCFZ)}
                      >
                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__yVvCw
                          )}
                        >
                          {"Well organised"}
                        </div>

                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__zlYDj
                          )}
                        >
                          {
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum."
                          }
                        </div>
                      </p.Stack>
                    </p.Stack>
                  </p.Stack>

                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(defaultcss.all, sty.box__rkoUl)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__kxSu)}
                    >
                      <img
                        alt={""}
                        className={classNames(defaultcss.img, sty.img__mvenG)}
                        role={"img"}
                        src={featureIcons2A7CcvYjBqg}
                      />

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box__mkhlE)}
                      >
                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__vy97T
                          )}
                        >
                          {"Robust workflow"}
                        </div>

                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__jp7BR
                          )}
                        >
                          {
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum."
                          }
                        </div>
                      </p.Stack>
                    </p.Stack>

                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__hDcL)}
                    >
                      <div
                        data-plasmic-name={"featureIcons3"}
                        data-plasmic-override={overrides.featureIcons3}
                        className={classNames(
                          defaultcss.all,
                          sty.featureIcons3
                        )}
                      >
                        <img
                          alt={""}
                          className={classNames(defaultcss.img, sty.img__mD0Hi)}
                          role={"img"}
                          src={group9H8Y41LzW38C}
                        />
                      </div>

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box__joLsv)}
                      >
                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__cXe6L
                          )}
                        >
                          {"Flexibility"}
                        </div>

                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__q70M
                          )}
                        >
                          {
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum."
                          }
                        </div>
                      </p.Stack>
                    </p.Stack>

                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__iHrbL)}
                    >
                      <div
                        data-plasmic-name={"featureIcons4"}
                        data-plasmic-override={overrides.featureIcons4}
                        className={classNames(
                          defaultcss.all,
                          sty.featureIcons4
                        )}
                      >
                        <img
                          alt={""}
                          className={classNames(defaultcss.img, sty.img__qjqXu)}
                          role={"img"}
                          src={group10PKp2ECbRBy}
                        />
                      </div>

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box__f4HlS)}
                      >
                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box___3F7Vs
                          )}
                        >
                          {"User friendly"}
                        </div>

                        <div
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.box__lPp8Y
                          )}
                        >
                          {
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum."
                          }
                        </div>
                      </p.Stack>
                    </p.Stack>
                  </p.Stack>
                </p.Stack>
              </p.Stack>

              <div
                data-plasmic-name={"coolDots52"}
                data-plasmic-override={overrides.coolDots52}
                className={classNames(defaultcss.all, sty.coolDots52)}
              >
                <CoolDots58Icon
                  className={classNames(defaultcss.all, sty.svg__ncbz0)}
                  role={"img"}
                />

                <CoolDots54Icon
                  className={classNames(defaultcss.all, sty.svg__reYf)}
                  role={"img"}
                />
              </div>

              <Vector102Icon
                className={classNames(defaultcss.all, sty.svg___1KhLs)}
                role={"img"}
              />

              <CoolDots59Icon
                className={classNames(defaultcss.all, sty.svg___7Sd9)}
                role={"img"}
              />
            </div>

            <div
              data-plasmic-name={"footerSection2"}
              data-plasmic-override={overrides.footerSection2}
              className={classNames(defaultcss.all, sty.footerSection2)}
            >
              <div className={classNames(defaultcss.all, sty.box__cgi9C)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(defaultcss.all, sty.box___3X8V)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(defaultcss.all, sty.box__bs6Pv)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box___3Jl0J)}
                    >
                      <div
                        className={classNames(
                          defaultcss.all,
                          defaultcss.__wab_text,
                          sty.box__fp8V
                        )}
                      >
                        {"Get In Touch"}
                      </div>

                      <div
                        data-plasmic-name={"paragraph2"}
                        data-plasmic-override={overrides.paragraph2}
                        className={classNames(
                          defaultcss.all,
                          defaultcss.__wab_text,
                          sty.paragraph2
                        )}
                      >
                        {"the quick fox jumps over the \nlazy dog"}
                      </div>

                      <p.Stack
                        as={"div"}
                        data-plasmic-name={"socialMedia2"}
                        data-plasmic-override={overrides.socialMedia2}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.socialMedia2)}
                      >
                        <p.PlasmicLink
                          data-plasmic-name={"facebook2"}
                          data-plasmic-override={overrides.facebook2}
                          className={classNames(defaultcss.all, sty.facebook2)}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          <img
                            alt={""}
                            className={classNames(
                              defaultcss.img,
                              sty.img__xox69
                            )}
                            role={"img"}
                            src={antDesignfacebookFilled2PQaf164UQa}
                          />
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          data-plasmic-name={"instagram2"}
                          data-plasmic-override={overrides.instagram2}
                          className={classNames(defaultcss.all, sty.instagram2)}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          <AntDesigninstagramOutlined2Icon
                            className={classNames(
                              defaultcss.all,
                              sty.svg__bp4MS
                            )}
                            role={"img"}
                          />
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          data-plasmic-name={"twitter2"}
                          data-plasmic-override={overrides.twitter2}
                          className={classNames(defaultcss.all, sty.twitter2)}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          <img
                            alt={""}
                            className={classNames(
                              defaultcss.img,
                              sty.img__xrtmx
                            )}
                            role={"img"}
                            src={antDesigntwitterOutlined2Xdr24EpeWh}
                          />
                        </p.PlasmicLink>
                      </p.Stack>
                    </p.Stack>

                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__fjgu0)}
                    >
                      <div
                        className={classNames(
                          defaultcss.all,
                          defaultcss.__wab_text,
                          sty.box__xVpjt
                        )}
                      >
                        {"Company info"}
                      </div>

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box___66Zom)}
                      >
                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link___1KLpT
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"About Us"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link__k99Zz
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"Contact Us"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link__yOc9S
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"We are hiring"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link___8ECn7
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"Blog"}
                        </p.PlasmicLink>
                      </p.Stack>
                    </p.Stack>

                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__c6PIo)}
                    >
                      <div
                        className={classNames(
                          defaultcss.all,
                          defaultcss.__wab_text,
                          sty.box__ummct
                        )}
                      >
                        {"Features"}
                      </div>

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box__sw23S)}
                      >
                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link__g0Xke
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"Business Marketing"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link__xuWZw
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"User Analytic"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link__gf3IO
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"Live Chat"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link___1HlMb
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"Unlimited Support"}
                        </p.PlasmicLink>
                      </p.Stack>
                    </p.Stack>

                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(defaultcss.all, sty.box__gWsE4)}
                    >
                      <div
                        className={classNames(
                          defaultcss.all,
                          defaultcss.__wab_text,
                          sty.box__dt1Fu
                        )}
                      >
                        {"Resources"}
                      </div>

                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(defaultcss.all, sty.box__whhQp)}
                      >
                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link___9Pw0L
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"IOS & Android"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link__x440
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"Watch a Demo"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link__w4BlN
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"Customers"}
                        </p.PlasmicLink>

                        <p.PlasmicLink
                          className={classNames(
                            defaultcss.all,
                            defaultcss.__wab_text,
                            sty.link___2CzhM
                          )}
                          component={Link}
                          href={"#"}
                          platform={"gatsby"}
                        >
                          {"API"}
                        </p.PlasmicLink>
                      </p.Stack>
                    </p.Stack>
                  </p.Stack>
                </p.Stack>
              </div>

              <div className={classNames(defaultcss.all, sty.box__y8EzG)}>
                <div className={classNames(defaultcss.all, sty.box__bn4Wq)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(defaultcss.all, sty.box__en2Yu)}
                  >
                    <div
                      data-plasmic-name={"colMd62"}
                      data-plasmic-override={overrides.colMd62}
                      className={classNames(defaultcss.all, sty.colMd62)}
                    >
                      <div
                        data-plasmic-name={
                          "madeWithLoveByTonyeBrownAllRightReserved2"
                        }
                        data-plasmic-override={
                          overrides.madeWithLoveByTonyeBrownAllRightReserved2
                        }
                        className={classNames(
                          defaultcss.all,
                          defaultcss.__wab_text,
                          sty.madeWithLoveByTonyeBrownAllRightReserved2
                        )}
                      >
                        {"Made With Love By Tonye Brown. All Right Reserved "}
                      </div>
                    </div>
                  </p.Stack>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const PlasmicDescendants = {
  root: [
    "root",
    "mntnBlue2",
    "homeHeroSection2",
    "home2",
    "line",
    "circle",
    "account2",
    "middleLinks2",
    "rectangle594",
    "content2",
    "coolDots1",
    "cloudComputingImg2",
    "layer12",
    "aboutSection2",
    "trafalgarIllustrationSec032",
    "cardItem2",
    "flexRow2",
    "inputGroup2",
    "formControlInputStyle12",
    "inputGroupAppend2",
    "logosSection2",
    "logos2",
    "fedExLogo2",
    "g152",
    "testimonialsSection2",
    "simpleTransparent2",
    "testimonials2",
    "rectangle18",
    "maskGroup2",
    "image2",
    "arrowNav2",
    "featuresSection2",
    "features2",
    "featureMultiple6",
    "autoAddedFrame2",
    "titleDescription6ColCenterAlign2",
    "title6ColCenterAlign2",
    "sectionTitle2",
    "featuresList2",
    "featureIcons5",
    "featureIcons6",
    "featureIcons9",
    "featureIcons3",
    "featureIcons4",
    "coolDots52",
    "footerSection2",
    "paragraph2",
    "socialMedia2",
    "facebook2",
    "instagram2",
    "twitter2",
    "colMd62",
    "madeWithLoveByTonyeBrownAllRightReserved2",
  ],

  mntnBlue2: [
    "mntnBlue2",
    "homeHeroSection2",
    "home2",
    "line",
    "circle",
    "account2",
    "middleLinks2",
    "rectangle594",
    "content2",
    "coolDots1",
    "cloudComputingImg2",
    "layer12",
    "aboutSection2",
    "trafalgarIllustrationSec032",
    "cardItem2",
    "flexRow2",
    "inputGroup2",
    "formControlInputStyle12",
    "inputGroupAppend2",
    "logosSection2",
    "logos2",
    "fedExLogo2",
    "g152",
    "testimonialsSection2",
    "simpleTransparent2",
    "testimonials2",
    "rectangle18",
    "maskGroup2",
    "image2",
    "arrowNav2",
    "featuresSection2",
    "features2",
    "featureMultiple6",
    "autoAddedFrame2",
    "titleDescription6ColCenterAlign2",
    "title6ColCenterAlign2",
    "sectionTitle2",
    "featuresList2",
    "featureIcons5",
    "featureIcons6",
    "featureIcons9",
    "featureIcons3",
    "featureIcons4",
    "coolDots52",
    "footerSection2",
    "paragraph2",
    "socialMedia2",
    "facebook2",
    "instagram2",
    "twitter2",
    "colMd62",
    "madeWithLoveByTonyeBrownAllRightReserved2",
  ],

  homeHeroSection2: [
    "homeHeroSection2",
    "home2",
    "line",
    "circle",
    "account2",
    "middleLinks2",
    "rectangle594",
    "content2",
    "coolDots1",
    "cloudComputingImg2",
    "layer12",
  ],

  home2: ["home2"],
  line: ["line"],
  circle: ["circle"],
  account2: ["account2"],
  middleLinks2: ["middleLinks2"],
  rectangle594: ["rectangle594"],
  content2: ["content2"],
  coolDots1: ["coolDots1"],
  cloudComputingImg2: ["cloudComputingImg2", "layer12"],
  layer12: ["layer12"],
  aboutSection2: [
    "aboutSection2",
    "trafalgarIllustrationSec032",
    "cardItem2",
    "flexRow2",
    "inputGroup2",
    "formControlInputStyle12",
    "inputGroupAppend2",
    "logosSection2",
    "logos2",
    "fedExLogo2",
    "g152",
  ],

  trafalgarIllustrationSec032: ["trafalgarIllustrationSec032"],
  cardItem2: [
    "cardItem2",
    "flexRow2",
    "inputGroup2",
    "formControlInputStyle12",
    "inputGroupAppend2",
  ],

  flexRow2: [
    "flexRow2",
    "inputGroup2",
    "formControlInputStyle12",
    "inputGroupAppend2",
  ],

  inputGroup2: ["inputGroup2", "formControlInputStyle12", "inputGroupAppend2"],
  formControlInputStyle12: ["formControlInputStyle12"],
  inputGroupAppend2: ["inputGroupAppend2"],
  logosSection2: ["logosSection2", "logos2", "fedExLogo2", "g152"],
  logos2: ["logos2", "fedExLogo2", "g152"],
  fedExLogo2: ["fedExLogo2", "g152"],
  g152: ["g152"],
  testimonialsSection2: [
    "testimonialsSection2",
    "simpleTransparent2",
    "testimonials2",
    "rectangle18",
    "maskGroup2",
    "image2",
    "arrowNav2",
  ],

  simpleTransparent2: ["simpleTransparent2"],
  testimonials2: [
    "testimonials2",
    "rectangle18",
    "maskGroup2",
    "image2",
    "arrowNav2",
  ],

  rectangle18: ["rectangle18"],
  maskGroup2: ["maskGroup2", "image2"],
  image2: ["image2"],
  arrowNav2: ["arrowNav2"],
  featuresSection2: [
    "featuresSection2",
    "features2",
    "featureMultiple6",
    "autoAddedFrame2",
    "titleDescription6ColCenterAlign2",
    "title6ColCenterAlign2",
    "sectionTitle2",
    "featuresList2",
    "featureIcons5",
    "featureIcons6",
    "featureIcons9",
    "featureIcons3",
    "featureIcons4",
    "coolDots52",
  ],

  features2: ["features2"],
  featureMultiple6: [
    "featureMultiple6",
    "autoAddedFrame2",
    "titleDescription6ColCenterAlign2",
    "title6ColCenterAlign2",
    "sectionTitle2",
    "featuresList2",
    "featureIcons5",
    "featureIcons6",
    "featureIcons9",
    "featureIcons3",
    "featureIcons4",
  ],

  autoAddedFrame2: [
    "autoAddedFrame2",
    "titleDescription6ColCenterAlign2",
    "title6ColCenterAlign2",
    "sectionTitle2",
  ],

  titleDescription6ColCenterAlign2: [
    "titleDescription6ColCenterAlign2",
    "title6ColCenterAlign2",
    "sectionTitle2",
  ],

  title6ColCenterAlign2: ["title6ColCenterAlign2", "sectionTitle2"],
  sectionTitle2: ["sectionTitle2"],
  featuresList2: [
    "featuresList2",
    "featureIcons5",
    "featureIcons6",
    "featureIcons9",
    "featureIcons3",
    "featureIcons4",
  ],

  featureIcons5: ["featureIcons5"],
  featureIcons6: ["featureIcons6"],
  featureIcons9: ["featureIcons9"],
  featureIcons3: ["featureIcons3"],
  featureIcons4: ["featureIcons4"],
  coolDots52: ["coolDots52"],
  footerSection2: [
    "footerSection2",
    "paragraph2",
    "socialMedia2",
    "facebook2",
    "instagram2",
    "twitter2",
    "colMd62",
    "madeWithLoveByTonyeBrownAllRightReserved2",
  ],

  paragraph2: ["paragraph2"],
  socialMedia2: ["socialMedia2", "facebook2", "instagram2", "twitter2"],
  facebook2: ["facebook2"],
  instagram2: ["instagram2"],
  twitter2: ["twitter2"],
  colMd62: ["colMd62", "madeWithLoveByTonyeBrownAllRightReserved2"],
  madeWithLoveByTonyeBrownAllRightReserved2: [
    "madeWithLoveByTonyeBrownAllRightReserved2",
  ],
}

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicHomepage__ArgProps,
      internalVariantPropNames: PlasmicHomepage__VariantProps,
    })

    const { dataFetches } = props
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      dataFetches,
      forNode: nodeName,
    })
  }
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage"
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`
  }
  return func
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    mntnBlue2: makeNodeComponent("mntnBlue2"),
    homeHeroSection2: makeNodeComponent("homeHeroSection2"),
    home2: makeNodeComponent("home2"),
    line: makeNodeComponent("line"),
    circle: makeNodeComponent("circle"),
    account2: makeNodeComponent("account2"),
    middleLinks2: makeNodeComponent("middleLinks2"),
    rectangle594: makeNodeComponent("rectangle594"),
    content2: makeNodeComponent("content2"),
    coolDots1: makeNodeComponent("coolDots1"),
    cloudComputingImg2: makeNodeComponent("cloudComputingImg2"),
    layer12: makeNodeComponent("layer12"),
    aboutSection2: makeNodeComponent("aboutSection2"),
    trafalgarIllustrationSec032: makeNodeComponent(
      "trafalgarIllustrationSec032"
    ),

    cardItem2: makeNodeComponent("cardItem2"),
    flexRow2: makeNodeComponent("flexRow2"),
    inputGroup2: makeNodeComponent("inputGroup2"),
    formControlInputStyle12: makeNodeComponent("formControlInputStyle12"),
    inputGroupAppend2: makeNodeComponent("inputGroupAppend2"),
    logosSection2: makeNodeComponent("logosSection2"),
    logos2: makeNodeComponent("logos2"),
    fedExLogo2: makeNodeComponent("fedExLogo2"),
    g152: makeNodeComponent("g152"),
    testimonialsSection2: makeNodeComponent("testimonialsSection2"),
    simpleTransparent2: makeNodeComponent("simpleTransparent2"),
    testimonials2: makeNodeComponent("testimonials2"),
    rectangle18: makeNodeComponent("rectangle18"),
    maskGroup2: makeNodeComponent("maskGroup2"),
    image2: makeNodeComponent("image2"),
    arrowNav2: makeNodeComponent("arrowNav2"),
    featuresSection2: makeNodeComponent("featuresSection2"),
    features2: makeNodeComponent("features2"),
    featureMultiple6: makeNodeComponent("featureMultiple6"),
    autoAddedFrame2: makeNodeComponent("autoAddedFrame2"),
    titleDescription6ColCenterAlign2: makeNodeComponent(
      "titleDescription6ColCenterAlign2"
    ),

    title6ColCenterAlign2: makeNodeComponent("title6ColCenterAlign2"),
    sectionTitle2: makeNodeComponent("sectionTitle2"),
    featuresList2: makeNodeComponent("featuresList2"),
    featureIcons5: makeNodeComponent("featureIcons5"),
    featureIcons6: makeNodeComponent("featureIcons6"),
    featureIcons9: makeNodeComponent("featureIcons9"),
    featureIcons3: makeNodeComponent("featureIcons3"),
    featureIcons4: makeNodeComponent("featureIcons4"),
    coolDots52: makeNodeComponent("coolDots52"),
    footerSection2: makeNodeComponent("footerSection2"),
    paragraph2: makeNodeComponent("paragraph2"),
    socialMedia2: makeNodeComponent("socialMedia2"),
    facebook2: makeNodeComponent("facebook2"),
    instagram2: makeNodeComponent("instagram2"),
    twitter2: makeNodeComponent("twitter2"),
    colMd62: makeNodeComponent("colMd62"),
    madeWithLoveByTonyeBrownAllRightReserved2: makeNodeComponent(
      "madeWithLoveByTonyeBrownAllRightReserved2"
    ),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
  }
)

export default PlasmicHomepage
/* prettier-ignore-end */
